import { render } from "./ProjectsCardMinimal.vue?vue&type=template&id=46a1a2ec&scoped=true"
import script from "./ProjectsCardMinimal.vue?vue&type=script&lang=js"
export * from "./ProjectsCardMinimal.vue?vue&type=script&lang=js"

import "./ProjectsCardMinimal.vue?vue&type=style&index=0&id=46a1a2ec&scoped=true&lang=css"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a1a2ec"]])

export default __exports__